import React from "react";
import { Container } from "reactstrap";
//
import Video from "../../Video";

export default ({ name, url, autoplay }) => (
  <Container className={`component-${name}`}>
    <Video url={url} playing={autoplay} />
  </Container>
);



// WEBPACK FOOTER //
// /Users/pauloamgomes/Sites/CockpitReactStatic/react-app/src/components/cockpit/Video/Video.js